import styled from 'styled-components';
import * as styleHelpers from '../../helpers/styleHelpers';

export const H1 = styled.h1`
  color: ${props =>
    props.light ? props.theme.colors.light : props.theme.colors.dark};
  font-weight: 800;
  letter-spacing: 0.25em;
  font-size: ${2 * 1.4}rem;
  line-height: 3rem;
  opacity: 0.9;
  // writing-mode: vertical-rl;
  margin-bottom: 0;
  font-family: ${props => props.theme.fonts.heading};

  ${props => styleHelpers.breakPoint(props.theme.breakPoints['lrg'])} {
    font-size: 3rem;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export const H2 = styled.h2`
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 0;
`;

export const H3 = styled.h3``;

export const P = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 1.5rem;
`;



// WEBPACK FOOTER //
// ./src/components/primitives/typography.js